/** Maximum inclusive UTC span accepted by every reporting endpoint. */
export const MAXIMUM_REPORTING_RANGE_DAYS = 3_660;
/** Keeps the fixed 30-day landing range guaranteed to include a mature day. */
export const MAXIMUM_ATTRIBUTION_MATURITY_DAYS = 29;
/** Maximum duration boundary accepted by reporting filters. */
export const MAXIMUM_REPORT_DURATION_SECONDS = 86_400;
/** Maximum paginated video rows returned by one report request. */
export const MAXIMUM_REPORT_ROWS = 1_000;
/** Maximum number of composite video series returned by a trend breakout. */
export const MAXIMUM_TREND_SERIES = 20;
/** Governed trend payload ceiling: one point per series for every allowed day. */
export const MAXIMUM_TREND_POINTS = MAXIMUM_REPORTING_RANGE_DAYS * MAXIMUM_TREND_SERIES;
//# sourceMappingURL=reporting-constants.js.map